module.exports = __webpack_public_path__ + "static/media/help.9155c3a6.png";